import styled from 'styled-components'
import { styled as muiStyled } from '@mui/material'

export const MPSettingsSectionHeader = styled.div`
  border-bottom: 1px solid #ccc;
  width: 100%;
  background: #fff;
`

export const MPSettingsListContainer = styled.div`
  display: flex;
  min-width: 200px;
  flex-direction: column;
  border-right: 1px solid #ccc;
  @media (max-width: 768px) {
    width: 100%;
    display: ${(props) => props?.removableOnSmall && 'none'};
  }
`

export const MPSettingsListItem = muiStyled('div')(({theme, selected})=>`
  border-bottom: 1px solid #ccc;
  transition: all 200ms ${theme.transitions.easing.easeInOut};
  padding: 16px;
  cursor: pointer;
  background: ${selected ?  theme.palette.emrPrimary.light : '#fff'};
  color: ${selected? '#fff' : '#000'};
  &:hover {
    background: ${selected ? theme.palette.emrPrimary.main : '#ebebeb'};
  }
`)
